/**
 * Pure post-processing config helpers — kept free of `@react-three/*`
 * imports so they can be unit-tested in a plain node environment.
 */

/** Default EffectComposer multisampling when the prop is omitted. */
export const DEFAULT_MULTISAMPLING = 2;

/** Resolve the EffectComposer `multisampling` value (clamped to >= 0). */
export function resolveMultisampling(value?: number): number {
  if (typeof value !== 'number' || !Number.isFinite(value) || value < 0) {
    return DEFAULT_MULTISAMPLING;
  }
  return Math.floor(value);
}
